exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ni-form .required .ni-form-item-label::after {\n  content: '*';\n  color: red;\n  position: relative;\n  top: 2px;\n  left: 4px;\n}\n.ni-form .ni-form-item:not(:last-of-type) {\n  margin-bottom: 12px;\n}\n.ni-form .ni-form-item .ni-form-item-label {\n  color: rgba(72, 72, 102, 0.92);\n  margin: auto 0;\n}\n.ni-form .ni-form-item .ni-form-row-extra {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.ni-form .ni-form-item .ni-form-item-content > span {\n  margin-top: 4px;\n  display: block;\n}\n.ni-form .ni-form-item .ni-form-item-content > .ant-switch {\n  margin-top: 4px;\n}\n", ""]);

// exports
